import { render } from "./ticketsThrowDetail.vue?vue&type=template&id=655438be"
import script from "./ticketsThrowDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsThrowDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/ticketsThrowDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "655438be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655438be', __exports__)) {
    console.log('reload')
    api.reload('655438be', __exports__)
  }
  
  module.hot.accept("./ticketsThrowDetail.vue?vue&type=template&id=655438be", () => {
    console.log('re-render')
    api.rerender('655438be', render)
  })

}


export default __exports__